import { IArtistRole, ArtistRoleEntity } from "./types";

/**
 * ArtistRole entity schema convert to model
 */
export function mapArtistRoleFromEntity(entity: ArtistRoleEntity): IArtistRole {
    return {
        id: entity.id,
        key: entity.key,
        title: entity.title,
        description: entity.description,
        language: entity.language,
        relationId: entity.languageRelationId,
        createdBy: entity.createdBy,
        updatedBy: entity.modifiedBy,
        createdAt: entity.createdOn || entity.CreatedOn,
        updatedAt: entity.modifiedOn || entity.ModifiedOn
    }
}

/**
 * ArtistRole model schema convert to entity
 */
export function mapArtistRoleFromModel(model: IArtistRole): ArtistRoleEntity {
    return {
        id: model.id,
        key: model.key,
        title: model.title,
        description: model.description,
        language: model.language,
        languageRelationId: model.relationId || undefined
    }
}

